import React from 'react';
import type { ScheduleStationPayload } from '../../../../../interfaces/schedule';
import ScheduleDropdown, {
  type ScheduleDropdownOption,
} from './ScheduleDropdown';

type Props = {
  stations: ScheduleStationPayload[];
  activeStationId: string;
  onChange: (stationId: string) => void;
};

export default function ScheduleStationSelect({
  stations,
  activeStationId,
  onChange,
}: Props) {
  const options = React.useMemo<ScheduleDropdownOption[]>(
    () =>
      stations.map((station) => ({
        label: station.title,
        value: station.id,
        hint: station.shortTitle,
      })),
    [stations],
  );

  return (
    <div className="schedule-station-select">
      <ScheduleDropdown
        value={activeStationId}
        options={options}
        placeholder="Selecionar rádio"
        variant="floating"
        ariaLabel="Selecionar rádio"
        onChange={onChange}
      />
    </div>
  );
}
